<template>
    <div ref="pdfContent">
        <!-- First Receipt -->
        <div style="
				border-left: 5px solid #039a67;
				border-bottom: 5px solid #039a67;
			">
            <div class="row ps-2">
                <div class="w-100 pb-2 d-flex akkurate-deposit-border justify-content-between align-items-center institution-header">
                    <div class="pt-2 ps-2 d-flex flex-column justify-content-between  h-100">
                        <p class="fw-bold mb-3 report-l-text">AUDIT TRAIL</p>
                        <div class="d-flex flex-column mt-auto">
                            <p class="mb-0 report-s-text text-uppercase">
                                {{ institution?.name }}
                            </p>
                            <p class="mb-0 report-s-text">{{ institution?.postal }}</p>
                            <p class="mb-0 report-s-text">
                                TEL: {{ institution?.telephone }}/ MOB:{{
                                    institution?.mobile
                                }}
                            </p>
                            <p class="mb-0 report-s-text">
                                EMAIL: {{ institution?.email }}
                            </p>

                            <p class="mb-0 report-l-text">
                                DATE:
                                <span class="fw-bold">{{ formatDateAndTime(data?.updated_at) }}</span>
                            </p>
                        </div>
                    </div>

                    <div class="col-md-3 col-3">
                        <p class="mb-0 fw-bold">
                            {{ getUserNoUN }}
                        </p>
                    </div>

                    <div class="col-md-2 col-2">
                        <div class="d-flex align-items-center justify-content-center">
                            <img class="img-fluid img-visibility" :src="require('@/assets/img/default_logo.png')" />
                        </div>
                        <div class="text-center">
                            <p class="m-0 fw-bold fst-italic motto-small">
                                {{ institution?.motto }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <!-- <div class="row ps-2">
                <div class="col-md-12 col-12 text-center mt-2">
                    <p class="fw-bold report-l-text"></p>
                </div>
            </div> -->
            <!-- <div class="row ms-0 ps-2">
                <div class="col">
                    <p class="mb-0 report-l-text text-uppercase">
                        BRANCH:
                        <span class="fw-bold">{{ getBranch }}</span>
                    </p>
                </div>


            </div>
            <hr /> -->
            <!-- <div class="row ms-0 ps-2 mt-2">
                <div class="col">
                    <p class="report-l-text">
                        NARRATION:
                        <span class="fw-bold">{{ data.narration }}</span>
                    </p>
                </div>
                <div class="col text-end">
                    <p class="report-l-text">
                        CHEQUE NO:
                        <span class="fw-bold">{{ data.cheque_number }}</span>
                    </p>
                </div>
            </div> -->

            <div class="row ms-0 ps-2 mt-2 trans_details">
                <!-- <b-table-simple hover small caption-top responsive>
					<template v-if="isLoading">
						<b-spinner
							label="Loading..."
							variant="primary"
							size="lg"
							class="d-block mx-auto"></b-spinner>
					</template>
<template v-else>
						<b-thead>
							<b-tr>
								<b-th>COA code</b-th>
								<b-th>Name</b-th>
								<b-th>Type</b-th>
								<b-th>Dr amount</b-th>
								<b-th>Cr amount</b-th>
							</b-tr>
						</b-thead>
						<tbody>
							<b-tr v-for="(value, item) in items" :key="item">
								<b-td>{{ value.COA_code }}</b-td>
								<b-td>{{ value.name }}</b-td>
								<b-td>{{ value.type }}</b-td>
								<b-td>{{
									displayNumber(value.dr_amount)
								}}</b-td>
								<b-td>{{
									displayNumber(value.cr_amount)
								}}</b-td>
							</b-tr>
						</tbody>
						<b-tfoot>
							<b-tr>
								<b-th colspan="3"> Total </b-th>
								<b-th>
									{{ displayNumber(getTotalDrAmount) }}
								</b-th>
								<b-th>
									{{ displayNumber(getTotalCrAmount) }}
								</b-th>
							</b-tr>
						</b-tfoot>
					</template>
</b-table-simple> -->
                <div class="row">
                    <div class="col-12">
                        <beat-loader-component v-if="isLoading" :isLoading="isLoading"></beat-loader-component>
                    </div>
                    <div class="col-12 col-md-6">
                        <label class="akkurate-dark" for="log_name">Log Name</label>
                        <b-form-group id="log_name" label-for="log_name">
                            <b-form-input class="mb-3 mt-2 field-container fields" type="text" v-model="getLogName" disabled></b-form-input>
                        </b-form-group>
                    </div>
                    <div class="col-12 col-md-6">
                        <label class="akkurate-dark" for="event">Event</label>
                        <b-form-group id="event" label-for="event">
                            <b-form-input class="mb-3 mt-2 field-container fields" type="text" v-model="getEvent" disabled></b-form-input>
                        </b-form-group>
                    </div>
                    <div class="col-12 col-md-6">
                        <label class="akkurate-dark" for="updated_at">Date And Time</label>
                        <b-form-group id="updated_at" label-for="updated_at">
                            <b-form-input class="mb-3 mt-2 field-container fields" type="text" :value="formatDateAndTime(data.updated_at)" disabled></b-form-input>
                        </b-form-group>
                    </div>
                    <div class="col-12 col-md-6">
                        <label class="akkurate-dark" for="updated_at">User</label>
                        <b-form-group id="updated_at" label-for="updated_at">
                            <b-form-input class="mb-3 mt-2 field-container fields" type="text" v-model="getUser" disabled></b-form-input>
                        </b-form-group>
                    </div>
                    <div class="col-12">
                        <label class="akkurate-dark" for="description">Description</label>
                        <b-form-group id="description" label-for="description">
                            <b-form-textarea class="mb-3 mt-2 field-container fields" v-model="getDescription" disabled></b-form-textarea>
                        </b-form-group>
                    </div>

                </div>
            </div>
        </div>
        <!-- <div class="row ms-0 ps-2 mt-2">
			<div class="col">
				<div class="akkurate-dark small">Prepared by:</div>
				<div class="akkurate-dark small fw-bold">
					{{
						data.created_by.first_name +
						" " +
						data.created_by.surname
					}}
				</div>
			</div>
			<div class="col text-end">
				<div class="akkurate-dark small">Approved by:</div>
				<div class="akkurate-dark small fw-bold">
					{{
						data.created_by.first_name +
						" " +
						data.created_by.surname
					}}
				</div>
			</div>
		</div>

		<div class="row ms-0 ps-2 mt-3">
			<div class="col">
				_______________________________
				<div class="small">Branch Manager</div>
			</div>
			<div class="col text-end">
				_______________________________
				<div class="small text-capitalize">
					{{ data.created_by.roles[0].name }}
				</div>
			</div>
		</div>

		<div class="row ms-0 ps-2 mt-3">
			<div class="col">
				<div class="small fw-bold">PAYEE/BENEFICIARY</div>
				<div class="small">
					{{ data.beneficiary_name }}
				</div>
			</div>
		</div>
		<div class="row ms-0 ps-2 mt-3">
			<div class="col">
				<div class="col">
					_______________________________
					<div class="small">Signature and Date</div>
				</div>
			</div>
		</div> -->
    </div>
</template>
<script>
import html2pdf from "html2pdf.js";
import Institution from "@/views/main/components/institution/Institution.vue";
import ApiService from "@/core/services/api.service";
export default {
    components: {
        Institution,
    },
    props: ["data", "institution"],
    data() {
        return {
            isPrinting: false,
            items: [],
            isLoading: false,
        };
    },
    mounted() {
        // if (this.data.id) {
        //     this.getJournalView(this.data.id);
        // }
    },
    computed: {
        getTotalDrAmount() {
            return this.items.reduce(
                (sum, item) => sum + item.dr_amount,
                0
            );
        },
        getTotalCrAmount() {
            return this.items.reduce(
                (sum, item) => sum + item.cr_amount,
                0
            );
        },
        getBranch() {
            if (this.data.branch) {
                return this.data.branch.name;
            }
            return "";

        },
        getLogName() {
            if (this.data.log_name.toLowerCase() == "account") {
                return this.data.log_name + " - " + this.data.subject?.account_number;
            }
            else {
                return this.data.log_name;
            }
        },
        getEvent() {
            if (this.data.event) {
                return this.data.event;
            }
            return this.data.log_name || "";
        },
        getDescription() {
            let description = this.data.description || "";
            if (this.data.causer?.narration) {
                description += ' (' + this.data.causer?.narration + ')';
            }
            if (this.data.subject?.account_number) {
                description += ' - ' + this.data.subject?.account_number + ' (' + this.data.subject.account_name + ')';
            }
            // if (this.data.subject?.loan_number && this.data.subject?.loan_type) {
            //     description += ' - ' + this.data.subject.loan_number + ' (' + this.data.subject.loan_type + ')';
            // }
            if (this.data.subject?.loan_number && this.data.subject?.principal_amount) {
                description += ' - ' + this.data.subject.loan_number + (this.data.subject?.reason ? ' (' + this.data.subject.reason + ')' : '') + ', Amount: GHS' + this.data.subject.principal_amount + (this.data.subject?.loan_type ? ', ' + this.data.subject.loan_type : '');
            }
            if (this.data?.causer && this.data?.causer.trans_amount) {
                description += ' - Amount: GHS ' + this.data.causer.trans_amount;
            }

            return description;
        },
        getUser() {
            if (this.data.causer && this.data.causer.first_name && this.data.causer.surname) {
                return this.data.causer
                    ?.first_name + (this.data.causer.middle_name ? " " + this.data.causer.middle_name : "") + " " + this.data.causer?.surname + " - " + this.data.causer?.id + " (" +
                    this.data.causer?.username + ")";
            }
            return "";
        },
        getUserNoUN() {
            if (this.data.causer && this.data.causer.first_name && this.data.causer.surname) {
                return this.data.causer
                    ?.first_name + (this.data.causer.middle_name ? " " + this.data.causer.middle_name : "") + " " + this.data.causer?.surname + " - " + this.data.causer?.id;
            }
            return "";
        },
    },
    methods: {
        getJournalView(id = null) {
            this.isLoading = true;
            ApiService.get(`/vouchers/view/${id}`)
                .then((response) => {
                    const account = [];
                    // this.form = response.data.data;
                    console.log(response.data.data);
                    this.items =
                        response.data.data.vouch_journal_coaaccounts.map(
                            (index) => {
                                return {
                                    COA_code: index.id,
                                    name: index.coa_sub_head.name,
                                    type: index.coa_sub_head.coatype.name,
                                    dr_amount: index.dr_amount,
                                    cr_amount: index.cr_amount,
                                };
                            }
                        );
                    // console.log(response.data.data.vouch_journal_coaaccounts);
                    this.isLoading = false;
                })
                .catch((error) => {
                    this.isLoading = false;
                    console.log(error);
                });
        },
        exportToPDF() {
            const content = this.$refs.pdfContent; // Reference to the HTML content you want to convert
            // console.log("here");
            const pdfOptions = {
                margin: 10,
                filename: "generated.pdf",
                image: { type: "jpeg", quality: 0.98 },
                html2canvas: { scale: 2, useCROS: true },
                jsPDF: {
                    unit: "mm",
                    format: "a4",
                    orientation: "portrait",
                },
            };
            html2pdf().from(content).set(pdfOptions).save();
        },
        generatePDF() {
            // Define the element to convert to a PDF
            const element = this.$refs.pdfContent; // Replace with your element's ID or selector
            // console.log(elementToConvert);

            // Define the options for html2pdf
            const pdfOptions = {
                margin: 4,
                filename: "document.pdf",
                image: { type: "jpeg", quality: 0.98 },
                html2canvas: { scale: 2, useCROS: true },
                jsPDF: {
                    unit: "mm",
                    format: "a4",
                    orientation: "portrait",
                },
                debug: true, // Enable debugging
            };
            html2pdf()
                .from(element)
                .set(pdfOptions)
                .toPdf()
                .get("pdf")
                .then((pdf) => {
                    var totalPages = pdf.internal.getNumberOfPages();
                    var insit_name = this.institution.name;
                    var insit_tele = this.institution.telephone;
                    var insit_email = this.institution.email;
                    var insit_motto = this.institution.motto;

                    for (var i = 1; i <= totalPages; i++) {
                        pdf.setPage(i);
                        pdf.setFontSize(8);
                        pdf.setTextColor(150);
                        pdf.text(
                            [
                                "For Inquiries, Please Contact " +
                                insit_name +
                                ", Customer Service on " +
                                insit_tele +
                                "",
                                "or email us on " +
                                insit_email +
                                " " +
                                insit_motto +
                                "",
                                "Page " + i + " of " + totalPages,
                            ],
                            pdf.internal.pageSize.getWidth() / 2,
                            pdf.internal.pageSize.getHeight() - 8,
                            { align: "center" }
                        );
                    }

                    // Get the blob of the PDF
                    return pdf.output("blob");
                })
                .then((pdfBlob) => {
                    // Create a URL for the PDF blob
                    var pdfUrl = URL.createObjectURL(pdfBlob);

                    // Open the URL in a new tab
                    const printWindow = window.open(
                        pdfUrl,
                        "_blank",
                        "width=800,height=600"
                    );
                    printWindow.onload = () => {
                        printWindow.print();
                        // URL.revokeObjectURL(url);
                    };
                })
                .catch((error) => {
                    console.error("Error generating PDF:", error);
                });
        },
    },
};
</script>
